import { faCircleMinus } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { Text } from '@growtherapy/sprout-ui';

import { Toast } from '../../toasts/Toast';
import { ModifiedToastAria, ToastVariant } from '../../toasts/types';

export function RecordingControlMultipleParticipantsToast({
  contentProps,
  descriptionProps,
  titleProps,
  ...toastAriaProps
}: ModifiedToastAria) {
  const t = useTranslate();
  return (
    <Toast {...toastAriaProps} variant={ToastVariant.Info} icon={faCircleMinus}>
      <div {...contentProps}>
        <span className='sr-only' {...titleProps}>
          {t('telehealth-core:recording.transcriptionHasBeenDisabled')}
        </span>
        <Text as='span' {...descriptionProps}>
          {t('telehealth-core:recording.transcriptionIsNotAvailableForMultipleParticipants')}
        </Text>
      </div>
    </Toast>
  );
}
